"use strict";

import { addFields } from "./calcs/fastfootEstimator";
import { calculateFoldDistance } from "./calcs/foldLineCalculator";
import { calculateBracing } from "./calcs/bracingEstimator";
import { calculateFabric } from "./calcs/fastfootEstimator";
import { runCostCompare } from "./calcs/fastfootCostEstimator";
import { getInputsData, becomeDealerLogic, resetInputs } from "./dealers_map"

const lang = "en"

export const urls = {
  investor: {
    financials: "investor/financials",
    stockChart: "investor/stock-chart",
    newProducts: "investor/new-products",
    pressReleases: "investor/press-releases",
    agm: "investor/agm",
    governance: "investor/governance",
    about: "investor/about",
    tmxFbf: "https://money.tmx.com/en/quote/FBF",
    compensationCommitteeCharter: "investor/compensation-committee-charter",
    codeBusinessConduct: "investor/code-business-conduct",
    auditCommitteeCharter: "investor/audit-committee-charter",
    corporateGovernanceGuidelines: "investor/corporate-governance-guidelines",
    privatePlacement: "investor/private-placement",
    tsx: "investor/tsx-venture-50",
  },
  zontBracing: {
    tallWall: "zont-icf-bracing/tall-wall",
    overview: "zont-icf-bracing/overview",
    installation: "zont-icf-bracing/installation",
    estimator: "zont-icf-bracing/estimator",
    sunflower: "zont-icf-bracing/sunflower",
    components: {
      zont: "zont-icf-bracing/zont",
      zuckle: "zont-icf-bracing/zuckle",
      zat: "zont-icf-bracing/zat",
      zee: "zont-icf-bracing/zee",
      zeveler: "zont-icf-bracing/zeveler",
      zote: "zont-icf-bracing/zote",
    },
    projects: "zont-icf-bracing/projects",
    specifications: "zont-icf-bracing/specifications",
    tomBackhoe: "zont-bracing/projects/tom-backhoe"
  },
  fastFoot: {
    residential: {
      overview: "fastfoot-residential/overview",
      installation: "fastfoot-residential/installation",
      risingDamp: "fastfoot-residential/rising-damp",
      fastPad: "fastfoot-residential/overview",
      green: "fastfoot-residential/overview",
      estimator: "fastfoot-residential/estimator",
      projects: "fastfoot-residential/projects",
      specifications: "fastfoot-residential/specifications",
      sewnCorner: "fastfoot-residential/new-sewn-corner",
      foldedCorners: "fastfoot-residential/folded-corners",
      cmhcMoldReport: "fastfoot-residential/cmhc-mold-report",
      marketingMaterials: "fastfoot-residential/marketing-materials"
    },
    commercial: {
      overview: "fastfoot-commercial/overview",
      installation: "fastfoot-commercial/installation",
      greenLantern: "fastfoot-commercial/projects/green-lantern",
      estimator: "fastfoot-commercial/estimator",
      projects: "fastfoot-commercial/projects",
      specifications: "fastfoot-commercial/specifications",
    },
  },
  monopour: {
    mpss: {
      installation: "monopour/mpss-installation",
      overview: "monopour/mpss-overview",
      projects: "monopour/mpss-projects",
      specifications: "monopour/mpss-specifications",
      doorBuck: "monopour/mpss/fastfoot-mp-door-buck",
      foldLineLocation: "monopour/fold-line-location",
      fastfootMpManufacture: "monopour/fastfoot-mp-manufacture"
    },
    mphd: {
      overview: "monopour/mphd-overview",
      installation: "monopour/mphd-installation"
    },
  },
  fastTube: {
    overview: "fast-tube/overview",
    installation: "fast-tube/installation",
    costEffective: "fast-tube/cost-effective",
    sunset: "fast-tube/projects/sunset",
    projects: "fast-tube/projects",
    specifications: "fast-tube/specifications",
    faq: "fast-tube/faq",
    rain: "fast-tube/projects/rain"
  },
  levelr: {
    overview: "level-r/overview",
  },
  spacer: {
    overview: "space-r/overview",
  },
  pages: {
    buyNow: "buy-now"
  }
};

export const calcForms = [
  {
    button: "estimate_add",
    form: "calc_ff_form",
    callback: addFields,
    url: "estimator",
  },
  {
    button: "estimate-cost-ff",
    form: "estimator",
    callback: runCostCompare,
    url: "estimator",
  },
  {
    button: "fieldDistance_button",
    form: "foldDistance",
    callback: calculateFoldDistance,
    url: "mpss-installation",
  },
  {
    button: "zontBracing_button",
    form: "zontEstimator",
    callback: calculateBracing,
    url: "zont-icf-bracing",
  },
  {
    button: "fastfoot_button",
    form: "fastfootCalc",
    callback: calculateFabric,
    url: "fastfoot-mp-manufacture",
  },
  {
    button: "getDealers",
    form: "zipCodeForm",
    callback: (event) => getInputsData(event),
    url: "buy-now",
  },
  {
    button: "getDealerForm",
    callback: becomeDealerLogic,
    url: "buy-now",
  },
    {
    button: "shopOnline",
    callback: () => window.open("https://shop.fab-form.com/shop", "_blank"),
    url: "buy-now",
  },
  {
    button: "resetForm",
    form: "zipCodeForm",
    callback: (event) => resetInputs(event),
    url: "buy-now",
  }
];

export const tradingWidgetConfig = {
    "fullscreen": true,
    "symbol": "TSXV:FBF",
    "interval": "D",
    "timezone": "America/Vancouver",
    "theme": "Light",
    "style": "8",
    "locale": "en",
    "toolbar_bg": "#f1f3f6",
    "enable_publishing": false,
    "hide_top_toolbar": true,
    "container_id": "tradingview_c4dab"
}

export const productTitles = {
    "fastFootForms": "Fastfoot Residential",
    "fastFootCom": "Fastfoot Commercial",
    "fastTube": "Fast-Tube",
    "monopour": "ICF Monopour",
    "zont-bracing": "Zont Bracing"
}

export const videoContent = {
  [`/${lang}`]: window.innerWidth > 1024
    ? "/videos/fab-form-home-desktop.mov"
    : "/videos/fab-form-home-mobile.mov",
  [`/${lang}/${urls.fastTube.overview}`]: window.innerWidth > 1024
    ? "/videos/fast-tube-canada-open.mov"
    : "/videos/fast-tube-canada-mobile.mov",
  [`/${lang}/${urls.fastFoot.residential.overview}`]: window.innerWidth > 1024
    ? "/videos/fastfoot-residential-desktop.mov"
    : "/videos/fastfoot-residential-mobile.mov",
  [`/${lang}/${urls.fastFoot.commercial.overview}`]: window.innerWidth > 1024
    ? "/videos/fastfoot-commercial-desktop.mov"
    : "/videos/fastfoot-commercial-mobile.mov",
  [`/${lang}/${urls.zontBracing.overview}`]: window.innerWidth > 1024
    ? "/videos/zont-bracing-desktop.mov"
    : "/videos/zont-bracing-mobile.mov",
  [`/${lang}/${urls.zontBracing.components.zont}`]: window.innerWidth > 1024
    ? "/videos/zont.mov"
    : "/videos/zont.mov",
  [`/${lang}/${urls.zontBracing.components.zat}`]: window.innerWidth > 1024
    ? "/videos/zat-bracket.mov"
    : "/videos/zat-bracket.mov",
  [`/${lang}/${urls.zontBracing.components.zee}`]: window.innerWidth > 1024
    ? "/videos/zee.mov"
    : "/videos/zee.mov",
  [`/${lang}/${urls.zontBracing.components.zeveler}`]: window.innerWidth > 1024
    ? "/videos/zeveler.mov"
    : "/videos/zeveler.mov",
  [`/${lang}/${urls.zontBracing.components.zote}`]: window.innerWidth > 1024
    ? "/videos/zote.mov"
    : "/videos/zote.mov",
  [`/${lang}/${urls.zontBracing.components.zuckle}`]: window.innerWidth > 1024
    ? "/videos/zuckle.mov"
    : "/videos/zuckle.mov",
  [`/${lang}/${urls.monopour.mphd.overview}`]: window.innerWidth > 1024
    ? "/videos/mphd.mov"
    : "/videos/mphd.mov",
  [`/${lang}/${urls.levelr.overview}`]: window.innerWidth > 1024
    ? "/videos/level-r-overview.mov"
    : "/videos/level-r-overview.mov",
}